import { render, staticRenderFns } from "./Github.vue?vue&type=template&id=09aa9244&"
import script from "./Github.vue?vue&type=script&lang=ts&"
export * from "./Github.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports